import React, { useState } from 'react';
import { Bot, User, Package, Menu, X } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { AuthModal } from './auth/AuthModal';
import { useUserStore } from '../stores/userStore';

export function Navbar() {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const profile = useUserStore((state) => state.profile);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    setIsMobileMenuOpen(false);
  };

  const NavLinks = () => (
    <>
      <div className="flex flex-col lg:flex-row gap-4 lg:gap-6">
        <Link
          to="/"
          className="hover:text-blue-500 transition-colors"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Home
        </Link>
        <Link
          to="/marketing"
          className="hover:text-blue-500 transition-colors"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Social Media Marketing
        </Link>
        <Link
          to="/automation"
          className="hover:text-blue-500 transition-colors"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Lead Rescue & Automation
        </Link>
        <Link
          to="/other-services"
          className="hover:text-blue-500 transition-colors"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Other Services
        </Link>
        <Link
          to="/pricing"
          className="hover:text-blue-500 transition-colors"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Pricing
        </Link>
      </div>

      {profile && (
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 lg:ml-6">
          <Link
            to="/profile"
            className="flex items-center gap-2 hover:text-blue-500 transition-colors"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <User className="w-5 h-5" />
            Profile
          </Link>
          <Link
            to="/my-services"
            className="flex items-center gap-2 hover:text-blue-500 transition-colors"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <Package className="w-5 h-5" />
            My Services
          </Link>
          <button
            onClick={handleSignOut}
            className="px-4 py-2 border-2 border-blue-500 text-blue-500 font-bold rounded-md hover:bg-blue-500/10 transition-colors w-full md:w-auto"
          >
            Sign Out
          </button>
        </div>
      )}
    </>
  );

  return (
    <>
      <nav className="fixed w-full bg-black/90 backdrop-blur-sm z-50 border-b border-blue-500/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <Link to="/" className="flex items-center gap-2">
              <Bot className="w-8 h-8 text-green-500" />
              <span className="text-xl font-bold text-white">
                Priority AI Services
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center text-gray-300">
              <NavLinks />
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-gray-300 hover:text-white"
            >
              {isMobileMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-black/95 border-t border-blue-500/20">
            <div className="px-4 py-6 space-y-4 text-gray-300">
              <NavLinks />
            </div>
          </div>
        )}
      </nav>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </>
  );
}